import Player from "@vimeo/player";
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { setClearAndStopMixerTrayTrack } from "../../Store/Slices/MyMixerSlice";
import { activeUser } from "../../Store/Slices/APIs";
import { removeAllTracks } from "../../Store/Slices/PlayerSlice";

const VimeoEmbedVideo = ({ embedHtml }) => {
  const containerRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    // Wait until the HTML has been injected
    const iframe = containerRef.current?.querySelector('iframe');
    if (!iframe) return;

    const player = new Player(iframe);

    player.on('play', () => {
      dispatch(setClearAndStopMixerTrayTrack(true));
      dispatch(activeUser());
      dispatch(removeAllTracks())
    });

    return () => {
      player.unload(); // Cleanup
      dispatch(setClearAndStopMixerTrayTrack(false));
    };
  }, []);

  return (
    <div ref={containerRef} dangerouslySetInnerHTML={{ __html: embedHtml }} />
  );
};

export default VimeoEmbedVideo;